module.exports = __webpack_public_path__ + "img/logo.d2b60126.png";